import { Component, DestroyRef, inject, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InvoiceFilter } from 'src/app/common/InvoiceFilter';
import { AppProfileService } from 'src/app/services/profile.service';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { InvoiceService } from 'src/app/services/invoice.service';
import { FormsModule } from '@angular/forms';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { FilterCardComponent } from '../filter-card/filter-card.component';
import { isDefaultFilter } from 'src/app/common/filter-state';

@Component({
    imports: [FormsModule, DateRangeFilterComponent, FilterCardComponent],
    selector: 'app-invoice-order-search',
    templateUrl: './invoice-order-search.component.html'
})
export class InvoiceOrderSearchComponent implements OnInit {
  private profileService = inject(AppProfileService);
  private invoiceService = inject(InvoiceService);

  private destroyRef = inject(DestroyRef);

  public profile: ExtendedProfile;
  public filter: InvoiceFilter;

  readonly searchCriteria = output<InvoiceFilter>();

  searchThis() {
    this.searchCriteria.emit(this.filter);
  }

  /** What the page opened with — the yardstick for the reset button (#228). */
  private defaults: InvoiceFilter = new InvoiceFilter(null, null, null, null);

  public get isFiltered(): boolean {
    return !isDefaultFilter({ ...this.filter }, { ...this.defaults });
  }

  public resetFilter(): void {
    this.filter = new InvoiceFilter(
      this.defaults.customerNameOrNumber,
      this.defaults.dateFrom,
      this.defaults.dateTo,
      this.defaults.invoiceGroupId
    );
    this.searchThis();
  }

  ngOnInit(): void {
    this.filter = this.invoiceService.getDefaultFilter();
    this.defaults = { ...this.filter };
    this.profileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((r) => {
      this.profile = r;
      this.searchThis();
    });
  }

  public customerChange(_value: string): void {
    this.searchCriteria.emit(this.filter);
  }
}
